module.exports = __webpack_public_path__ + "static/media/orangeroom.5250c22d.png";